import {
  getItemModel,
  getItemModelTemplate,
  createItemModel,
  getItemModelById,
  editItemModel,
  deleteItemModel,
} from "@/http/setup/itemModel.js";

export default {
  namespaced: true,
  state: {
    itemModels: [],
    provisionDatas: [],
    itemModelData: {},
  },
  actions: {
    async fetchItemModelList({ commit }) {
      try {
        const res = await getItemModel();
        commit("SET_ITEM_MODEL_LIST", res.data.pageItems);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteItemModelAction({ commit }, id) {
      try {
        let res = await deleteItemModel(id);
        commit("RESET_ITEM_MODEL_LIST", id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchItemModelTemplate({ commit }) {
      try {
        let res = await getItemModelTemplate();
        commit("SET_ITEM_MODEL_TEMPLATE", res.data.provisionDatas);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createItemModelAction(_, payload) {
      try {
        return await createItemModel(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editItemModelAction(_, payload) {
      try {
        return await editItemModel(payload.id, payload.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchItemModelById({ commit }, id) {
      try {
        let res = await getItemModelById(id);
        commit("SET_ITEM_MODEL", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_ITEM_MODEL_TEMPLATE(state, payload) {
      state.provisionDatas = payload;
    },
    SET_ITEM_MODEL(state, payload) {
      state.itemModelData = payload;
    },
    SET_ITEM_MODEL_LIST(state, payload) {
      state.itemModels = payload;
    },
    RESET_ITEM_MODEL_LIST(state, id) {
      state.itemModels = state.itemModels.filter((el) => el.id !== id);
    },
  },
};
